import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import useEkko from 'src/Common/Providers/EkkoProvider';

/**
 * This component logs out the user and redirects back to login.
 * Enables the /logout route.
 * Primarily required for the error boundary logout button, because the boundary is not within the API context itself.
 */
export const Logout = (): React.JSX.Element => {
  const { logOut, isAuthenticated } = useEkko();
  const navigate = useNavigate();

  useEffect(() => {
    if (isAuthenticated) {
      logOut();
    }
    navigate('/login');
  }, [logOut, isAuthenticated]);

  return <></>;
};
